import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bulleted-list-button",
  "use": "bulleted-list-button-usage",
  "viewBox": "0 0 60.123 60.123",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60.123 60.123\" id=\"bulleted-list-button\"><path d=\"M57.124 51.893H16.92a3 3 0 1 1 0-6h40.203a3 3 0 0 1 .001 6zm0-18.831H16.92a3 3 0 1 1 0-6h40.203a3 3 0 0 1 .001 6zm0-18.831H16.92a3 3 0 1 1 0-6h40.203a3 3 0 0 1 .001 6z\" /><circle cx=\"4.029\" cy=\"11.463\" r=\"4.029\" /><circle cx=\"4.029\" cy=\"30.062\" r=\"4.029\" /><circle cx=\"4.029\" cy=\"48.661\" r=\"4.029\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol